import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: `/api/hand/add/copy-crafts`,
    name: 'CRAFT_MANAGE_COPY',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
